// extracted by mini-css-extract-plugin
module.exports = {"indicator":"inlineIndicator_indicator__1WvUd"};